export enum UserRole {
    PROFESSIONAL = 'professional',
    PENDINGPROFESSIONAL = 'pending_professional',
    PENDINGPATIENT = 'pending_patient',
    VERIFYINGPROFESSIONAL = 'verifying_professional',
    BASE = 'base_user',
    ASSISTANT = 'assistant',
}